class HCLDX {
    static baseURL() {
        let r = this.get_REACT_APP_HCL_DX_BASE_URL();
        let u = '';
        if (r !== undefined) {
            u = r;
            if (window.avnet !== undefined &&
                window.avnet.siteId !== undefined) {
                u += window.avnet.siteId;
            }
        }
        return u;
    }

    static baseURLOfHCLDX() {
        return this.get_REACT_APP_HCL_DX_DOMAIN();
    }

    static get_REACT_APP_HCL_DX_BASE_URL() {
        // Temporary for Dev3 Dev1 FSP Application configured
        const hostname = window.location.href;
        if (hostname.includes('my.avnet.com')) {
            return 'https://my.avnet.com/';
        } else if (hostname.includes('my.dev3.avnet.com')) {
            return 'https://my.dev3.avnet.com/';
        } else if (hostname.includes('onesite-test5.avnet.com')) {
            return 'https://onesite-test5.avnet.com/';
        } else if (hostname.includes('onesite-uat5.avnet.com')) {
            return 'https://onesite-uat5.avnet.com/';
        }
        return process.env.REACT_APP_HCL_DX_BASE_URL;
    }

    static get_REACT_APP_HCL_DX_DOMAIN() {
        // Temporary for Dev3 Dev1 FSP Application configured 
        console.log("hostname: " + hostname);
        const hostname = window.location.href;
        if (hostname.includes('my.dev3.avnet.com')) {
            console.log("URL: https://my.dev3.avnet.com/");
            return 'https://my.dev3.avnet.com';
        }
        return process.env.REACT_APP_HCL_DX_DOMAIN;
    }
}

export default HCLDX;